import React, { useEffect, useState } from "react";
import DashboardShell from "../../components/DashboardShell";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";
import { Bell, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const sevStyles = {
  high: "bg-red-500/15 text-red-300 border-red-500/30",
  medium: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  low: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
};

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const load = () => api.get("/v1/alerts").then(r => setAlerts(r.data));
  useEffect(() => { load(); }, []);

  const resolve = async (a) => {
    await api.post(`/v1/alerts/${a.id}/resolve`);
    toast.success("Alert resolved");
    load();
  };

  return (
    <DashboardShell title="Alerts" subtitle="High-severity policy events routed to your on-call.">
      <div className="rounded-xl bg-white/5 border border-white/10 divide-y divide-white/5">
        {alerts.length === 0 && <div className="p-6 text-cream/50 text-sm">No alerts. Every request has been allow-listed by policy.</div>}
        {alerts.map(a => (
          <div key={a.id} data-testid={`alert-${a.id}`} className="p-4 flex items-start gap-4">
            <div className={`px-2 py-0.5 rounded-full border text-[11px] font-bold uppercase ${sevStyles[a.severity] || sevStyles.low} shrink-0 mt-1`}>{a.severity}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <Bell size={14} className="text-[#FF6B35]"/>
                <div className="font-semibold text-sm">{a.title}</div>
                {a.resolved && <span className="chip chip-cream text-[10px]"><CheckCircle2 size={10}/> resolved</span>}
              </div>
              <div className="text-cream/70 text-sm mt-1">{a.description}</div>
              <div className="text-[11px] text-cream/40 mt-1">{new Date(a.timestamp).toLocaleString()}</div>
            </div>
            <div className="flex gap-2 shrink-0">
              <Link to={`/app/decisions/${a.decision_id}`} className="btn-ghost-dark text-xs">View decision</Link>
              {!a.resolved && <button onClick={() => resolve(a)} className="btn-primary text-xs">Resolve</button>}
            </div>
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}
